import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import SixtyIForm from "./Form";
import { SETTING_TABLE_NAME } from "../../../constants/settingsTableName";
import { useDeviceConfigEntries } from "../../../hooks/useReduxSelectors";
import useSettings from "../../../hooks/useSettings";

const SixtyISettings = () => {
  const { t } = useTranslation("common");
  const deviceConfigs = useDeviceConfigEntries();
  const sixtyIConfig = deviceConfigs?.find((dev) => dev.hwId === "TEI_60i");

  const { formState, loading, error, fetchSettings } =
    useSettings(SETTING_TABLE_NAME.DEVICE_60I_SETTINGS, (res) => res);

  return (
    <Accordion sx={{ mb: 2 }} disableGutters onChange={(e, expanded) => { if (expanded) fetchSettings(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "primary.main", color: "common.white" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>60i</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: "background.light", p: 2 }}>
        {error && (
          <Typography sx={{ textAlign: "center", color: "secondary.main" }}>
            {t("No Settings Found")}
          </Typography>
        )}
        {!loading && formState && <SixtyIForm settings={formState} sixtyIConfig={sixtyIConfig} />}
      </AccordionDetails>
    </Accordion>
  );
};

export default SixtyISettings;
